import React from 'react';
import { useRouter } from 'next/router';

interface IHelp2Props {}

const Help2: React.FC<IHelp2Props> = ({}) => {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-xl border border-neutral-600 px-5 py-6 lg:flex-row">
      <div className="text-base font-medium text-white text-center whitespace-pre-line">
        Can&apos;t find the previous order? It can be retrieved with the
        recipient address
      </div>
      <div
        className="flex h-10  cursor-pointer items-center justify-center rounded-3xl bg-primary-500 px-4 text-sm font-medium text-white hover:bg-primary-600"
        onClick={() => {
          open('/myinscriptions');
        }}
      >
        My Inscriptions
      </div>
    </div>
  );
};

export default Help2;
